import store from '@/store'


export const POST_LEVEL={
  LEVEL_JU:'局级',
  LEVEL_BUMEN:'部门级'
}

export const POST_LEVEL_CODE={
  LEVEL_JU:1,
  LEVEL_BUMEN: 2,
}


/**
 * 获取对应职务级别下的职务列表
 * @param level
 * @returns {Promise<unknown>}
 */
function getPostsList(level) {
  return store.dispatch('getPostsList',level)
}

/**
 * 返回所有的职务属性
 * @returns {Promise<any>}
 */
function getPostAttributes() {
  return store.dispatch('getPostAttribute')
}
/**
 * 获取员工下拉列表
 * @returns {Promise<unknown>}
 */
function getEmployeeList() {
  return store.dispatch('getEmployeeList')
}




export default {
  getEmployeeList,
  getPostAttributes,
  getPostsList
}
